import { TimeTableProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TimeTableProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TimeTableProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      addItemButtonLabel: 'Add Task',
      columns: [
        {
          title: '1',
          subtitle: 'DAY',
          items: [{ content: 'Task 1' }],
          disabled: true,
        },
        {
          title: '2',
          subtitle: 'DAY',
          items: [
            {
              content: 'Task 2',
            },
            {
              content: 'Task 3',
              disabled: false,
            },
          ],
          disabled: true,
        },
      ],
    } as TimeTableProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
